import React from "react";
import { message, Table } from "antd";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Menu, Dropdown, Icon, Tooltip, Button } from "antd";
import moment from "moment";
import classnames from "classnames";

import Modal from "../../../modal/modal";

import Language from "../../../language/language";
import { $const, $util } from "../../../../helper";

import "../../stylesheets/teamMemberList.scss";

const { Column } = Table;

@inject("teamStore", "languageStore", "authStore")
@observer
@withRouter
export default class TeamMemberList extends React.Component {
  state = {
    showAllMember: false,
    showChangeCaptain: false,
    showKickOut: false,
    showAuthorise: false,
    prepareKickOutRecord: null,
    prepareAuthoriseRecord: null,
    memberId: undefined
  };
  componentDidMount() {
    // this.props.teamStore.getTeamInfo(this.props.id)
  }

  showConfirmOnKickOut = record => {
    this.setState({
      showKickOut: true,
      prepareKickOutRecord: record
    });
  };

  showConfirmOnAuthorise = record => {
    this.setState({
      showAuthorise: true,
      prepareAuthoriseRecord: record
    });
  };

  kickOut = record => {
    this.props.teamStore
      .exitTeam({
        variables: {
          input: {
            id: record.id
          }
        }
      })
      .then(() => {
        this.setState({
          showKickOut: false
        });
        // 这个用户在踢自己，返回管理中心
        if (record.memberId === this.props.authStore.user.id.toString()) {
          this.props.history.push("/control-center");
        } else {
          // 踢其他人
          this.props.teamStore.getTeamInfo(this.props.teamInfo.id);
        }
      });
  };

  // 授权
  updateManagementMarkAuthorisation(record) {
    this.closeAuthoriseModal();
    this.props.teamStore.updateManagementMark(record.id, true).then(res => {
      if (
        !this.props.teamStore.updateManagementMarkInfo ||
        this.props.teamStore.updateManagementMarkInfo.status !== $const.SERVER_STATUS.SUCCESS
      ) {
        message.error(
          this.props.languageStore.getResource(
            this.props.languageStore.lang,
            "AUTHORISATION_FAILED"
          )
        );
      }
      this.props.teamStore.getTeamInfo(this.props.teamInfo.id);
    });
  }

  // 取消授权
  updateManagementMarkAuthorisationCancel(record) {
    this.props.teamStore.updateManagementMark(record.id, false).then(() => {
      this.props.teamStore.getTeamInfo(this.props.teamInfo.id);
    });
  }

  // 只有队长可以转移队长权限
  changeCaptain = () => {
    this.props.teamStore
      .changeCaptain({
        variables: {
          input: {
            memberId: this.state.memberId,
            id: this.props.teamInfo.id
          }
        }
      })
      .then(() => {
        this.setState({
          showChangeCaptain: false
        });
      });
  };

  showChangeCaptainModal = memberId => {
    this.setState({
      showChangeCaptain: true,
      memberId: memberId
    });
  };
  closeChangeCaptainModal = () => {
    this.setState({
      showChangeCaptain: false
    });
  };

  closeKickOutModal = () => {
    this.setState({
      showKickOut: false,
      prepareKickOutRecord: null
    });
  };

  closeAuthoriseModal = () => {
    this.setState({
      showAuthorise: false,
      prepareAuthoriseRecord: null
    });
  };

  roleChange = (record, role) => {
    this.props.teamStore.updateTeamMember({
      variables: {
        input: {
          id: record.id,
          attributes: {
            teamId: record.teamId,
            memberId: record.memberId,
            eventRoleId: role.key
          }
        }
      }
    });
  };

  positionChange = (record, position) => {
    if (
      position &&
      position.item &&
      position.item.props &&
      position.item.props.code === $const.CAPTAIN
    ) {
      this.showChangeCaptainModal(record.memberId);
      return;
    }
    this.props.teamStore.updateTeamMember({
      variables: {
        input: {
          id: record.id,
          attributes: {
            teamId: record.teamId,
            memberId: record.memberId,
            eventPositionId: position.key
          }
        }
      }
    });
  };

  getPostions = game => {
    let positions = [];
    if (game && game.nodes.length > 0) {
      game.nodes.forEach(item => {
        if (item && item.position) {
          positions.push(item);
        }
      });
    }
    return positions;
  };

  getRoles = game => {
    let roles = [];
    if (game && game.nodes && game.nodes.length > 0) {
      game.nodes.forEach(item => {
        if (item && item.id) {
          roles.push(item);
        }
      });
    }
    return roles;
  };

  renderMenuRole = (record, roles) => {
    if (roles.length < 1) {
      return null;
    }
    return (
      <Menu onClick={this.roleChange.bind(this, record)}>
        {roles.map(item => {
          return (
            <Menu.Item key={item.id} teamid={record.teamId} position={record.eventPositionId}>
              {item.role.nameUuidI18n[this.props.languageStore.lang]}
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  renderMenuPosition = (record, positions, canCaptainEdit) => {
    if (positions.length < 1) {
      return null;
    }
    // 只有队长有权限授予其他人队长的能力，副队长只能授予除了队长以外的职位
    if (!canCaptainEdit) {
      positions = positions.filter(item => {
        if (item.position.code === $const.CAPTAIN) {
          return false;
        }
        return true;
      });
    }
    return (
      <Menu onClick={this.positionChange.bind(this, record)}>
        {positions.map(item => {
          return (
            <Menu.Item
              key={item.id}
              code={item.position.code}
              teamid={record.teamId}
              role={record.eventRoleId}
            >
              {item.position.nameUuidI18n[this.props.languageStore.lang]}
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  renderPositonNum = teamInfo => {
    const lang = this.props.languageStore.lang;
    return (
      <ul>
        {teamInfo.positionLimit.length > 0 &&
          teamInfo.positionLimit.map(position => {
            if (position.min === undefined || position.max === undefined) {
              return null;
            }
            let name = "";
            position.eventPositions &&
              position.eventPositions.length > 0 &&
              position.eventPositions.forEach((item, index) => {
                if (item && item.eventPosition && item.eventPosition.position) {
                  name += `${index > 0 ? "+" : ""}${
                    item.eventPosition.position.nameUuidI18n[lang]
                  }`;
                }
              });
            if (name && name.split("+").length > 1) {
              name = "【" + name + "】";
            }
            return (
              <li
                className={classnames({
                  "not-enough": position.num < position.min || position.num > position.max
                })}
                key={position.id}
              >
                <span>{name}</span>
                {` ${position.num}/(${position.min}-${position.max})`}
              </li>
            );
          })}
      </ul>
    );
  };

  membersChange = () => {
    this.setState({
      showAllMember: !this.state.showAllMember
    });
  };

  render() {
    const teamInfo = this.props.teamInfo;
    const lang = this.props.languageStore.lang;
    let members = [];
    if (teamInfo && teamInfo.gteamMembers && teamInfo.gteamMembers.nodes) {
      members = [...teamInfo.gteamMembers.nodes];
    } else {
      return <div className="team-member-list"></div>;
    }
    members = members.map(item => {
      return {
        id: item.id,
        teamId: this.props.teamInfo.id,
        memberId: item.memberId,
        avatar: item.member.avatar,
        name: item.member.nickname,
        position: item.position.nameUuidI18n[lang],
        positionCode: item.position.code,
        school: item.member.collegeName,
        year:
          item.member.educations &&
          item.member.educations.nodes &&
          item.member.educations.nodes.length > 0 &&
          item.member.educations.nodes[0].beginAt
            ? moment(item.member.educations.nodes[0].beginAt).format("YYYY-MM")
            : "-",
        major:
          item.member.educations &&
          item.member.educations.nodes &&
          item.member.educations.nodes.length > 0
            ? item.member.educations.nodes[0].major
            : "",
        role: item.role && item.role.nameUuidI18n[lang],
        eventPositionId: item.eventPositionId,
        eventRoleId: item.eventRoleId,
        teamManagementMark: item.teamManagementMark
      };
    });
    let positions = this.getPostions(teamInfo.gevent.eventPositions);
    let roles = this.getRoles(teamInfo.gevent.eventRoles);
    return (
      <div className={classnames("team-member-list", this.props.className)}>
        <Table
          title={() => this.props.languageStore.getResource(lang, "TEAMMEMBER_LIST")}
          scroll={{ x: this.props.canCaptainEdit || this.props.canSubCaptainEdit ? 1200 : 900 }}
          dataSource={
            teamInfo.status === $const.TEAM_STATUS.LOCKED &&
            members.length > 3 &&
            !this.state.showAllMember
              ? members.slice(0, 3)
              : members
          }
          pagination={false}
          rowKey="id"
        >
          {/* 头像 */}
          <Column
            width={120}
            key="avatar"
            render={(text, record) => (
              <div className="avatar">
                <img
                  src={
                    $util.getSafePicUrl(record.avatar)
                      ? $util.getSafePicUrl(record.avatar)
                      : $const.DEFAULT_AVATAR
                  }
                  alt={record.name}
                />
              </div>
            )}
          ></Column>
          {/* 名字 */}
          <Column
            title={<Language resource="TEAM_MEMBERS" />}
            width={160}
            key="name"
            render={(text, record) => {
              return (
                <div className="name">
                  <Tooltip title={record.name}>
                    <div>{record.name && record.name.slice(0, 10)}</div>
                  </Tooltip>
                  {//判断是否是队长或者是被授予权限的队员 是的话 就在后面加上管理者的icon
                  record.positionCode === $const.CAPTAIN || record.teamManagementMark ? (
                    <img
                      className="admin-icon"
                      src="https://rm-static.djicdn.com/robomasters/dps/c085e952f52fe88b491afe86a3e98e64.png"
                      alt="admin-icon"
                    />
                  ) : null}
                </div>
              );
            }}
          ></Column>
          {/* 职位 */}
          {(this.props.canCaptainEdit || this.props.canSubCaptainEdit) && positions.length > 0 ? (
            <Column
              title={<Language resource="POSITION" />}
              dataIndex="position"
              width={160}
              key="position"
              render={(text, record) => {
                // 不允许改变队长的职位
                if (record.positionCode === $const.CAPTAIN) {
                  return <span>{record.position}</span>;
                }
                return (
                  <Dropdown
                    overlay={this.renderMenuPosition(record, positions, this.props.canCaptainEdit)}
                  >
                    <div className="ant-dropdown-link spe-link">
                      {record.position && record.position.slice(0, lang === "zh" ? 4 : 8)}{" "}
                      <Icon type="down" />
                    </div>
                  </Dropdown>
                );
              }}
            ></Column>
          ) : (
            <Column
              title={<Language resource="POSITION" />}
              width={100}
              key="position"
              render={(text, record) => {
                return (
                  <div className="position">
                    <Tooltip title={record.position}>
                      <span>
                        {record.position && record.position.slice(0, lang === "zh" ? 6 : 12)}
                      </span>
                    </Tooltip>
                  </div>
                );
              }}
            ></Column>
          )}
          {/* 角色 */}
          {(this.props.canCaptainEdit || this.props.canSubCaptainEdit) && roles.length > 0 ? (
            <Column
              title={<Language resource="ROLE" />}
              dataIndex="role"
              width={170}
              align="center"
              key="role"
              render={(text, record) => {
                // 副队长不能编辑队长的角色
                if (
                  !this.props.canCaptainEdit &&
                  this.props.canSubCaptainEdit &&
                  record.positionCode === $const.CAPTAIN
                ) {
                  return (
                    <div className="role">
                      <Tooltip title={record.role}>
                        <span>{record.role && record.role.slice(0, lang === "zh" ? 8 : 16)}</span>
                      </Tooltip>
                    </div>
                  );
                }
                return (
                  <Dropdown overlay={this.renderMenuRole(record, roles)}>
                    <div className="ant-dropdown-link spe-link">
                      {record.role && record.role.slice(0, lang === "zh" ? 6 : 12)}{" "}
                      <Icon type="down" />
                    </div>
                  </Dropdown>
                );
              }}
            ></Column>
          ) : (
            <Column
              title={<Language resource="ROLE" />}
              dataIndex="role"
              key="role"
              align="center"
              width={170}
              render={(text, record) => {
                return (
                  <div className="role">
                    <Tooltip title={record.role}>
                      <span>{record.role && record.role.slice(0, lang === "zh" ? 8 : 16)}</span>
                    </Tooltip>
                  </div>
                );
              }}
            ></Column>
          )}
          {/* 只有队长能够授予副队长权限 */}
          {this.props.canCaptainEdit ? (
            <Column
              key="authorise"
              align="center"
              title={
                <span>
                  <Language resource="AUTHORISATION_TITLE" />
                  <Tooltip
                    title={<Language resource="AUTHORISATION_NOTICE" />}
                    overlayClassName={lang === "zh" ? "tooltip-custom-zh" : "tooltip-custom-en"}
                  >
                    <span style={{ marginLeft: "4px" }}>
                      <Icon type="question-circle" style={{ color: "#1890ff" }} />
                    </span>
                  </Tooltip>
                </span>
              }
              width={120}
              render={(text, record) => {
                return (
                  <div className="operate">
                    {/* 不能给队长授权副队长 */}
                    {record.positionCode !== $const.CAPTAIN ? (
                      <div className="action">
                        {record.teamManagementMark === true ? (
                          <div
                            className="spe-link"
                            onClick={this.updateManagementMarkAuthorisationCancel.bind(
                              this,
                              record
                            )}
                          >
                            <Language resource="AUTHORISE_CANCEL"></Language>
                          </div>
                        ) : (
                          <div
                            className="spe-link"
                            onClick={this.showConfirmOnAuthorise.bind(this, record)}
                          >
                            <Language resource="AUTHORIZE"></Language>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                );
              }}
            ></Column>
          ) : null}

          {/* 队长与副队长均有权力踢出成员 */}
          {this.props.canCaptainEdit || this.props.canSubCaptainEdit ? (
            <Column
              key="action"
              align="center"
              title={<Language resource="KICK_OUT" />}
              width={120}
              render={(text, record) => {
                return (
                  <div className="operate">
                    {/* 不能踢出队长，但是副队长可以踢出自己 */}
                    {record.positionCode !== $const.CAPTAIN ? (
                      <div className="action">
                        <div
                          className="spe-link"
                          onClick={this.showConfirmOnKickOut.bind(this, record)}
                        >
                          <Language resource="KICK_OUT"></Language>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              }}
            ></Column>
          ) : null}
        </Table>
        <div className="member-num-info">{this.renderPositonNum(teamInfo)}</div>
        {teamInfo.status === $const.TEAM_STATUS.LOCKED && members.length > 3 ? (
          <div className="show-all-members">
            <div className="spe-link" onClick={this.membersChange}>
              {this.state.showAllMember ? <Icon type="up" /> : <Icon type="down" />}
              <Language resource="SHOW_ALL_MEMBERS" />
            </div>
          </div>
        ) : null}
        <Modal
          title={<Language resource="CHANGE_CAPTAIN" />}
          state={this.state.showChangeCaptain}
          close={this.closeChangeCaptainModal}
        >
          <div className="sub-title">
            <Language resource="CHANGE_CAPTAIN_TIP"></Language>
          </div>
          <div className="change">
            <Button type="primary" onClick={this.changeCaptain}>
              <Language resource="CHANGE"></Language>
            </Button>
          </div>
        </Modal>
        <Modal
          title={<Language resource="KICK_OUT_TITLE" />}
          state={this.state.showKickOut}
          close={this.closeKickOutModal}
        >
          <div className="sub-title">
            <Language resource="KICK_OUT_TIP"></Language>
          </div>
          <div className="change">
            <Button type="default" onClick={this.closeKickOutModal}>
              <Language resource="KICK_OUT_CANCEL"></Language>
            </Button>
            <Button
              type="primary"
              onClick={this.kickOut.bind(this, this.state.prepareKickOutRecord)}
            >
              <Language resource="KICK_OUT_CONFIRM"></Language>
            </Button>
          </div>
        </Modal>
        <Modal
          title={<Language resource="AUTHORISATION_DIALOG_TITLE" />}
          state={this.state.showAuthorise}
          close={this.closeAuthoriseModal}
        >
          <div className="sub-title">
            <Language resource="AUTHORISATION_DIALOG_DESC"></Language>
          </div>
          <div className="change">
            <Button type="default" onClick={this.closeAuthoriseModal}>
              <Language resource="AUTHORISATION_DIALOG_CANCEL"></Language>
            </Button>
            <Button
              type="primary"
              onClick={this.updateManagementMarkAuthorisation.bind(
                this,
                this.state.prepareAuthoriseRecord
              )}
            >
              <Language resource="AUTHORISATION_DIALOG_CONFIRM"></Language>
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/teamInfoTabs/memberList.js